import { api } from "@/lib/api";

export const productionApi = {
  meta: () => api.get("/production/meta").then((r) => r.data),
  machines: (stage) => api.get("/production/machines", { params: { stage } }).then((r) => r.data),
  queue: (stage) => api.get(`/production/${stage}/queue`).then((r) => r.data),
  board: (stage) => api.get(`/production/${stage}/board`).then((r) => r.data),
  task: (id) => api.get(`/production/tasks/${id}`).then((r) => r.data),
  start: (id, body) => api.post(`/production/tasks/${id}/start`, body).then((r) => r.data),
  pause: (id, reason) => api.post(`/production/tasks/${id}/pause`, { reason }).then((r) => r.data),
  resume: (id) => api.post(`/production/tasks/${id}/resume`).then((r) => r.data),
  finish: (id, body) => api.post(`/production/tasks/${id}/finish`, body).then((r) => r.data),
  finishApproved: (id, body) => api.post(`/production/tasks/${id}/finish-approved`, body).then((r) => r.data),
  assign: (id, body) => api.post(`/production/tasks/${id}/assign`, body).then((r) => r.data),
  hold: (id, reason) => api.post(`/production/tasks/${id}/hold`, { reason }).then((r) => r.data),
  release: (id) => api.post(`/production/tasks/${id}/release`).then((r) => r.data),
  cancel: (id, reason) => api.post(`/production/tasks/${id}/cancel`, { reason }).then((r) => r.data),
  approveWastage: (id) => api.post(`/production/tasks/${id}/approve-wastage`).then((r) => r.data),
  releaseDispatch: (id) => api.post(`/production/tasks/${id}/release-dispatch`).then((r) => r.data),
  lineage: (batchId) => api.get(`/production/batches/${batchId}/lineage`).then((r) => r.data),
};

export const STATUS_STYLE = {
  QUEUED: "bg-slate-100 text-slate-700",
  ASSIGNED: "bg-blue-50 text-blue-700 border border-blue-200",
  IN_PROGRESS: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  PAUSED: "bg-amber-50 text-amber-700 border border-amber-200",
  PARTIALLY_COMPLETED: "bg-teal-50 text-teal-700 border border-teal-200",
  COMPLETED: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  ON_HOLD: "bg-orange-50 text-orange-700 border border-orange-200",
  REWORK: "bg-rose-50 text-rose-700 border border-rose-200",
  CANCELLED: "bg-gray-100 text-gray-500 line-through",
};

export const PRIORITY_STYLE = {
  Urgent: "bg-rose-600 text-white",
  High: "bg-amber-100 text-amber-800 border border-amber-300",
  Normal: "bg-slate-50 text-slate-600 border border-slate-200",
};

export const STAGE_TITLE = { printing: "Printing", fusing: "Fusing", cutting: "Cutting", stitching: "Stitching", packing: "Bundle Packing" };
